import { Modal } from '@innovamat/glimmer-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { SettingsTabType } from '../../../types';

const SETTINGS_TAB_PASSWORD: SettingsTabType = 'Password';

type PasswordExpirationComingSoonModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

function PasswordExpirationComingSoonModal({
  isOpen,
  onClose,
}: PasswordExpirationComingSoonModalProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNavigate = () => {
    onClose();
    navigate(`/settings?tab=${SETTINGS_TAB_PASSWORD}`);
  };

  return (
    <Modal
      isOpen={isOpen}
      closeButton="inner"
      onClose={onClose}
      title={t('password_expiration.coming_soon.title')}
      semantic={{
        type: 'warning',
        text: t('common.modal.important'),
      }}
      buttons={[
        {
          children: t('password_expiration.coming_soon.cta'),
          variant: 'accent',
          onClick: handleNavigate,
        },
      ]}
    >
      <p>{t('password_expiration.coming_soon.description')}</p>
    </Modal>
  );
}

export { PasswordExpirationComingSoonModal };
